import React, { useState, useEffect } from "react"

import "./ContainedImg.scss"

interface IProps {
  src: string
  className?: string
  testId?: string
  displaySize?: Quiz.Api.ImageDisplaySize
}

const useImageLoaded = (src: string) => {
  const [ loaded, setLoaded ] = useState(false)

  useEffect(() => {
    const img = new Image()
    img.onload = () => { setLoaded(true) }
    img.src = src

    return () => { // cleanup
      img.onload = null
    }
  }, [src])

  return loaded
}

const ContainedImgRaw: React.FC<IProps> = ({src, className: passThroughClassName, testId, displaySize}) => {
  const loaded = useImageLoaded(src)

  const className = [
    "neo__containedImg",
    `neo__containedImg--${displaySize ?? "default"}`,
    loaded ? "--loaded" : "--loading",
    passThroughClassName ?? "",
    passThroughClassName ? `${passThroughClassName}--${displaySize ?? "default"}` : "",
  ].join(" ")

  return (
    <div
      className={className}
      style={{backgroundImage: `url("${src}")`}}
      data-testid={testId} />
  )
}

const ContainedImg: React.FC<IProps> = (props) => { // to load a new image when src changes
  return <ContainedImgRaw key={props.src} {...props} />
}

export const ContainedImgWithCredit: React.FC<{ src: string, classForImg?: string, credit?: string }> = ({ src, classForImg, credit }) => {
  const loaded = useImageLoaded(src)

  const className = [
    "neo__containedImgWithCredit",
    credit ? "neo__containedImgWithCredit--withCredit" : "neo__containedImgWithCredit--withoutCredit",
    loaded ? "neo__containedImgWithCredit--loaded" : "neo__containedImgWithCredit--loading",
  ].join(" ")

  return <div className={className}>
    <img src={src} className={`neo__containedImgWithCredit__img ${classForImg ?? ""}`}/>
    {credit && <span>{credit}</span>}
  </div>
}

export default ContainedImg
